/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.repo.getRecord'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  repo: /*#__PURE__*/ l.string({ format: 'at-identifier' }),
  collection: /*#__PURE__*/ l.string({ format: 'nsid' }),
  rkey: /*#__PURE__*/ l.string({ format: 'record-key' }),
  cid: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ format: 'cid' })),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  uri: /*#__PURE__*/ l.string({ format: 'at-uri' }),
  cid: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ format: 'cid' })),
  value: /*#__PURE__*/ l.lexMap(),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Get a single record from a repository. Does not require auth. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ['RecordNotFound'])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
